import { Card, Tabs } from "antd";
import React from "react";
import AppSetting from "./AppSetting";
import Magazine from "./Magazine";

function AppSettingTab() {
  const items = [
    {
      key: "1",
      label: "AppSetting",
      children: <AppSetting />,
    },
    {
      key: "2",
      label: "Magazine",
      children: <Magazine />,
    },
  ];

  return (
    <div className="lms-body">
      <Card>
        <Tabs defaultActiveKey="1" items={items} />
      </Card>
    </div>
  );
}

export default AppSettingTab;